import React, { useMemo } from "react";

import Image from "../../components/image";
import FgasaLight from "../../images/icons/FGASA-light.svg";
import FgasaDark from "../../images/icons/FGASA.svg";
import ImpactLight from "../../images/icons/Impact-light.svg";
import ImpactDark from "../../images/icons/Impact.svg";
import PadiLight from "../../images/icons/PADI-light.svg";
import PadiDark from "../../images/icons/PADI.svg";
import { convertToSlug } from "../../utils/convertToSlug";
import { Link } from "../../utils/customLink";

const SubNavMenu = ({
  subTitle,
  data,
  className: containerClassName,
  subTitleClass,
  subtitleLink,
  subTitleLinkDesc = "",
  subTitleLinkActive = "false"
}) => {
  const menuIcons = {
    dark: {
      "impact-icon": ImpactDark,
      "fgasa-icon": FgasaDark,
      "padi-icon": PadiDark
    },
    light: {
      "impact-icon": ImpactLight,
      "fgasa-icon": FgasaLight,
      "padi-icon": PadiLight
    }
  };

  const dataSet = useMemo(() => data, [data]);

  return (
    <div className={`flex flex-col ${containerClassName}`}>
      {subTitleLinkActive === true ? (
        <div
          className={`w-full gvi-dark-gray-color border-b pb-3 border-border-light dark:border-gray-lighter mb-8 ${
            subTitleClass ?? ""
          }`}
        >
          <Link
            id={convertToSlug(subTitle)}
            to={subtitleLink ?? "#"}
            className={`uppercase active-link !px-0 pb-3 h5`}
          >
            {subTitle}
          </Link>
        </div>
      ) : (
        <Link
          id={convertToSlug(subTitle)}
          to={subtitleLink ?? "#"}
          className={`text-base font-semibold text-black-lighter dark:text-white py-1 ${
            subTitleClass ?? ""
          }`}
        >
          <div className="flex flex-col w-th-new-flag sub-title-container">
            <div className="flex items-center gap-x-5">
              <div
                className="sub-title"
                dangerouslySetInnerHTML={{ __html: subTitle }}
              />
              {/new-flag/gi.test(containerClassName) && (
                <div
                  className="py-0 px-2 font-normal bg-red-light dark:bg-green-standard text-white dark:text-gray-darkest text-xxxxs"
                  dangerouslySetInnerHTML={{ __html: "NEW!" }}
                />
              )}
            </div>

            {/show-desc|new-flag/gi.test(containerClassName) && (
              <div
                className="italic text-xxxs font-normal text-gray-lighter dark:text-gray-darkest"
                dangerouslySetInnerHTML={{ __html: subTitleLinkDesc }}
              />
            )}
          </div>
        </Link>
      )}

      {dataSet &&
        dataSet?.map((dataItem, index) => {
          let ImageIconDark,
            ImageIconLight = "";

          // eslint-disable-next-line default-case
          switch (true) {
            case subTitleClass?.includes("impact-icon"):
              ImageIconDark = menuIcons["light"]["impact-icon"];
              ImageIconLight = menuIcons["dark"]["impact-icon"];
              break;
            case subTitleClass?.includes("fgasa-icon"):
              ImageIconDark = menuIcons["light"]["fgasa-icon"];
              ImageIconLight = menuIcons["dark"]["fgasa-icon"];
              break;
            case subTitleClass?.includes("padi-icon"):
              ImageIconDark = menuIcons["light"]["padi-icon"];
              ImageIconLight = menuIcons["dark"]["padi-icon"];
              break;
          }

          return (
            <div className="flex pt-1" key={index}>
              {ImageIconDark && ImageIconLight && (
                <>
                  <Image
                    imageAlt=""
                    image={""}
                    imageClass="hidden w-6 h-6 mr-4 dark:block"
                    sourceUrl={ImageIconDark}
                  />

                  <Image
                    imageAlt=""
                    image={""}
                    imageClass="block w-6 h-6 p-1 mr-4 bg-white rounded-full dark:hidden"
                    sourceUrl={ImageIconLight}
                  />
                </>
              )}

              {dataItem.img}

              <Link
                id={convertToSlug(
                  dataItem?.title ?? dataItem?.label ?? dataItem
                )}
                className="my-auto text-xs text-black-lighter dark:text-gray-darken hover:text-white"
                to={dataItem?.path ?? dataItem?.url ?? "#"}
              >
                {dataItem?.title ?? dataItem?.label ?? dataItem}
              </Link>
            </div>
          );
        })}
    </div>
  );
};

export default React.memo(SubNavMenu);
